const swiftRegexp = /^[A-Z0-9]{8,11}$/;

export default swiftRegexp;
